module.exports = __webpack_public_path__ + "img/0F990F_047B04_044604_046704-256px.0d0eb2ba.png";